import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
})
export class CalendarComponent implements ControlValueAccessor {
  @Input() label!: string;
  @Input() iconSrc?: string;
  @Input() icon?: string;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() description?: string;
  @Input() errorMessages: string[] = [];

  // PrimeNG Calendar specific inputs
  @Input() dateFormat = 'dd/mm/yy';
  @Input() showTime = false;
  @Input() hourFormat: 12 | 24 = 24;
  @Input() showIcon = false;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  protected _value: Date | null = null;

  constructor(@Self() @Optional() public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  onChange: (value: Date | null) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: Date | null): void {
    this._value = value;
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  get value(): Date | null {
    return this._value;
  }

  set value(value: Date | null) {
    if (value !== this._value) {
      this._value = value;
      this.onChange(value);
    }
    this.onTouched();
  }

  public getValidationNgClasses(
    control: NgControl
  ): Record<string, boolean | null> {
    return {
      'ng-invalid': control?.invalid,
      'ng-valid': control?.valid,
      'ng-touched': control?.touched,
      'ng-untouched': !control?.touched,
      'ng-dirty': control?.dirty,
      'ng-pristine': control?.pristine,
    };
  }
}
